export default __webpack_public_path__ + "static/media/best_logo.4f6302e7.png";